import { ChangeEvent, MouseEvent, useContext } from 'react'

import { TablePagination } from '@material-ui/core'

import ContentManagementContext from '../../../ContentManagementProvider/Context'

interface PaginationProps {
  count: number
}

const Pagination = ({ count }: PaginationProps) => {
  const { from, pageSize, setFrom, setPageSize } = useContext(ContentManagementContext)

  const handlePageChange = (_: MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setFrom(newPage)
  }
  const handleRowsPerPageChange = (event: ChangeEvent<HTMLInputElement>) => {
    setPageSize(parseInt(event.target.value, 10))
    setFrom(0)
  }

  return (
    <TablePagination
      rowsPerPageOptions={[10, 25, 50]}
      component="div"
      count={count}
      rowsPerPage={pageSize}
      page={from}
      onPageChange={handlePageChange}
      onRowsPerPageChange={handleRowsPerPageChange}
    />
  )
}

export default Pagination
